
import { Component, EventEmitter, Input, OnInit } from '@angular/core';

import Swal from "sweetalert2";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { TypeOffer } from '../../../../../models/typeOffer.model';
import { IPost, Post } from '../../../../../models/post.model';
import { Product } from '../../../../../models/product.model';
import { Note } from '../../../../../models/avis.model';
import { Observable } from 'rxjs';
import { Param } from '../../../../../models/param.model';
import { Promotion } from '../../../../../models/promotion.model';
import { SubProductCharacteristic } from '../../../../../models/subProductCharacteristic.model';
import { TypeOfferService } from '../../../../../services/typeOffer.service';
import { PromotionApplyService } from '../../../../../services/promotion_apply.service';
import { PromotionService } from '../../../../../services/promotion.service';
import { PublicationService } from '../../../../../services/publication.service';
import { PostService } from '../../../../../services/post.service';
import { ProductService } from '../../../../../services/product.service';
import { ServiceService } from '../../../../../services/service.service';
import { ParamService } from '../../../../../services/param.service';
import { PostPromoteService } from '../../../../../services/postPromote.service';
import { environment } from '../../../../../environments/environment';
import { AddPromoteComponent } from '../../kahpoo-shop/post-promote/add-promote/add-promote.component';
import { PrivateSpaceService } from '../../../../../services/privateSpace.service';
import { IPrivateSpace } from '../../../../../models/privateSpace.model';
import { Location } from '@angular/common';

@Component({
  selector: 'app-variant-private-space',
  templateUrl: './variant-private-space.component.html',
  styleUrls: ['./variant-private-space.component.scss']
})
export class VariantPrivateSpaceComponent implements OnInit {

  selectedOfferType: TypeOffer;
  posts: Post[] = [];
  postTampons: Post[] = [];
  initialPosts: Post[] = [];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems: any;
  imageName: string | undefined = '';
  post!: Post;
  product!: Product;
  postUpdate!: Post;
  nbTotalPurchase: number = 0;
  url_photo: String;
  selected: boolean = false;
  unitTime: string[] = [];
  notePosts: Note[] = [];
  isHighlighted$: Observable<boolean>;
  search: any;
  postId: number;
  allowDeliveryChecked: boolean = false;
  // @ts-ignore
  public modalRef: BsModalRef;
  highlightedPosts: any[] = [];
  param: Param;
  paramPromo: Param;
  annonceEnPromotionDeKahpoo: any[] = [];
  kahooProductPromotionId: any;
  productPromotionId: any;
  kahooServicePromotionId: any;
  servicePromotionId: any;
  listKahpooPromo: any
  selectedPromotion: Promotion;
  postPromu: any;
  subProductCharact: SubProductCharacteristic[] = [];
  statusSearchText = '';
  searchText = '';
  privateSpaceId: number
  pr: any = {};
  constructor(private route: ActivatedRoute, private promotionService: PromotionService,
    private typeOfferService: TypeOfferService,
    private promotionApplyService: PromotionApplyService,
    private privateSpaceService: PrivateSpaceService,
    private postService: PublicationService,
    private postServicePost: PostService,
    private productService: ProductService,
    private servService: ServiceService,
    private fb: FormBuilder,
    private router: Router,
    private location: Location,
    private datePipe: DatePipe, private paramService: ParamService, private postPromoteService: PostPromoteService) {
    this.unitTime = ['Minutes', 'Heurs', 'Jours', 'Mois'];
  }

  ngOnInit(): void {

    this.privateSpaceId = Number(this.route.snapshot.paramMap.get('id'));
    this.allVariants();
    //this.loadAllPostInPrivateSpace()
    this.url_photo = environment.url_photo;
    this.getPrivateSpaceById()
    // this.isHighlighted$ = this.isIdInHighlightedPostsNew(this.postId);

  }
  privateSpace: IPrivateSpace
  getPrivateSpaceById() {
    this.privateSpaceService.getIdPrivateSpace(this.privateSpaceId).subscribe(data => {
      this.privateSpace = data;
      // console.log("l'espace privé")
      // console.log(this.privateSpace)

      // console.log("les user associé")
      // console.log(this.privateSpace)
    })
  }
  goBack(): void {
    this.location.back();
  }
  allPostPrivateSpace: Post[] = [];
  allPostPrivateSpaceTmp: Post[] = [];
  loadAllPostInPrivateSpace = () => {
    this.allPostPrivateSpace = []
    this.privateSpaceService.getPostInPrivateSpace(this.privateSpaceId).subscribe(rs => {
      this.allPostPrivateSpace = rs;
      // console.log("Annonce associé à l'espace privé");
      // console.log(this.allPostPrivateSpace);
    })
  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })



  isFilterByProduct: boolean = false;
  isFilterByService: boolean = false;
  isFilterByProductAndService: boolean = true;

  allVariant: any[] = [];

  allProductPrivate!: any
  allServicePrivate!: any

  displayedVariants: any[] = [];
  displayedVariantsTmp: any[] = [];


  allVariants() {
    this.searchText = this.search !== undefined ? this.search : '';

    this.privateSpaceService.getIdPrivateSpace(this.privateSpaceId).subscribe(data => {
      this.privateSpace = data;

      if (!this.allProductPrivate) {
        this.allProductPrivate = this.privateSpace.products.map(val => ({
          variantName: val.name,
          variantID: val.productID,
          categoryName: val.category?.name,
          variantType: "product",
        }));
      }

      if (!this.allServicePrivate) {
        this.allServicePrivate = this.privateSpace.services.map(val => ({
          variantName: val.titre,
          variantID: val.serviceID,
          categoryName: val.category?.name,
          variantType: "service",
        }));
      }

      // Fusionner les produits et services dans une seule liste
      this.allVariant = [...this.allProductPrivate, ...this.allServicePrivate];

      // Total des éléments pour la pagination
      this.totalItems = this.allVariant.length;

      // Mise à jour des éléments affichés pour la page actuelle
      this.updatePageData();
    });
  }

  // Méthode pour actualiser les données en fonction de la page
  updatePageData() {
    const startIndex = (this.pageNumber - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedVariants = this.allVariant.slice(startIndex, endIndex);
    this.displayedVariantsTmp = this.displayedVariants
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }



  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.updatePageData();
  }


  searchFilter($event: KeyboardEvent) {
    this.displayedVariants = this.displayedVariantsTmp.filter(
      value => value.variantName?.toLowerCase().includes(this.search) ||
        value.categoryName?.toLowerCase().includes(this.search) ||
        value.variantID?.toLowerCase().includes(this.search) ||
        value.variantType?.toLowerCase().includes(this.search)

    );
  }

  ascendingOrderDate: boolean = true;
  sortByDate() {
    this.posts.sort((a, b) => {
      const dateA = new Date(a.publishedAt);
      const dateB = new Date(b.publishedAt);
      if (this.ascendingOrderDate) {
        return dateA.getTime() - dateB.getTime();
      } else {
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderDate = !this.ascendingOrderDate;
  }

  ascendingOrder: boolean = true;


  ascendingPhone: boolean = true;


  ascendingOrderTitle: boolean = true;
  sortByTitle() {
    this.displayedVariants.sort((a, b) => {
      if (this.ascendingOrderTitle) {
        return a.variantName.toLowerCase().localeCompare(b.variantName.toLowerCase());
      } else {
        return b.variantName.toLowerCase().localeCompare(a.variantName.toLowerCase());
      }
    })
    this.ascendingOrderTitle = !this.ascendingOrderTitle;
  }

  ascendingOrderCategorie: boolean = true;
  sortByCategorie() {
    this.displayedVariants.sort((a, b) => {
      if (this.ascendingOrderCategorie) {
        return a.categoryName.toLowerCase().localeCompare(b.categoryName.toLowerCase());
      } else {
        return b.categoryName.toLowerCase().localeCompare(a.categoryName.toLowerCase());
      }
    })
    this.ascendingOrderCategorie = !this.ascendingOrderCategorie;
  }

  ascendingType: boolean = true;
  sortByType() {
    //// console.log(this.posts);
    this.displayedVariants.sort((a, b) => {
      if (this.ascendingType) {
        return a.variantType.toLowerCase().localeCompare(b.variantType.toLowerCase());
      } else {
        return b.variantType.toLowerCase().localeCompare(a.variantType.toLowerCase());
      }
    })
    this.ascendingType = !this.ascendingType;
  }




  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if (this.beginDateVal != null) {
      this.disableEndDate = false;
      if (this.beginDateVal > this.endDateVal) {
        this.displayErrorMessage = true;
      } else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //  // console.log(this.endDateVal);
    if (this.beginDateVal > this.endDateVal) {
      this.displayErrorMessage = true;
    } else {
      this.displayErrorMessage = false;
    }
  }


  refresh() {
    this.allVariants();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  getUrlPhoto() {
    this.imageName = this.post.postSubProducts[0].subProduct?.photo;
    if (this.imageName != null || this.imageName != undefined) {
      this.selected = true;
    } else {
      this.selected = false;
    }
  }

  getUrlPhoto1() {
    if (this.post.postSubProducts[0].subProduct?.photo1)
      this.imageName = this.post.postSubProducts[0].subProduct?.photo1;
    if (this.imageName != null || this.imageName != undefined) {
      this.selected = true;
    } else {
      this.selected = false;
    }
  }

  getUrlPhoto2() {
    if (this.post.postSubProducts[0].subProduct?.photo2)
      this.imageName = this.post.postSubProducts[0].subProduct?.photo2;
    if (this.imageName != null || this.imageName != undefined) {
      this.selected = true;
    } else {
      this.selected = false;
    }
  }


  strUcFirst(valeur: any) { return (valeur + '').charAt(0).toUpperCase() + valeur.substr(1); }


  strUcFirst2(valeur: any) {
    if (valeur != undefined) {
      return valeur?.promotionItem[0]?.value0
    }
  }

  strUcFirst3(valeur: any) {
    if (valeur != undefined) {
      return valeur?.promotionItem[0]?.value1
    }
  }

  strUcFirst4(valeur: any) {
    if (valeur != undefined) {
      return valeur?.promotionItem[0]?.value2
    }
  }


  removeProductOrServiceTPrivateSpace(pr: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer l\'élément de cet espace ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.privateSpaceService.removeProuctOrServiceToPrivateSpace(this.privateSpaceId, pr.variantID).subscribe(
          rs => {

            // // console.log("Response de la suppression")
            // // console.log(rs)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre élément est supprimé de la liste avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.allVariants();
            this.reloadComponent();
          }, error => {
            // // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error?.error?.errorMessage,
              showConfirmButton: false,
              timer: 5500
            })
          }
        )
      }
    })

  }


}
